import { render } from "./TrainingAttending.vue?vue&type=template&id=19584c64&scoped=true"
import script from "./TrainingAttending.vue?vue&type=script&lang=js"
export * from "./TrainingAttending.vue?vue&type=script&lang=js"

import "./TrainingAttending.vue?vue&type=style&index=0&id=19584c64&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19584c64"]])

export default __exports__